/**
 * Pendo track events for the Home page, used to measure the rollout
 * (which to-do kinds people act on, whether the 1:1 card gets used).
 * Does nothing when Pendo isn't loaded, e.g. in dev or with blockers.
 */
export function trackHome(
  event:
    | "home_todo_action"
    | "home_todo_tab"
    | "home_open_agenda"
    | "home_start_conversation"
    | "home_reschedule"
    | "home_resume_learning",
  properties: Record<string, string | number | boolean> = {},
) {
  try {
    window.pendo?.track?.(event, properties);
  } catch {
    // Analytics must never break the page.
  }
}
